import BaseModel from './base';
import { rServices } from '@/plugins/api';
import { localeFormatDefault } from '@/plugins/date-print';
import { PLAN_INCLUSION_TYPE, PLAN_INCLUSION_STATUS_DATA, PLAN_INCLUSION_TYPE_DATA, PLAN_INCLUSION_STATUS } from '@/modules/EventsPlan/constants';
import User from '@/utils/user';
import { ROLES, ROLES_DATA } from '@/constants/roles';
import Event from './event';
import { getAnnounDate } from '@/modules/EventsPlan/functions';

const requestsDataMap = (list, type) => {
  const defaultFieldData = {
    name: 'name',
    id: 'id',
  };
  const dataField = {
    [PLAN_INCLUSION_TYPE.organizers]: {
      ...defaultFieldData,
      name: 'short_name',
    },
    [PLAN_INCLUSION_TYPE.regions]: {
      ...defaultFieldData,
    },
    [PLAN_INCLUSION_TYPE.municipalities]: {
      ...defaultFieldData,
    },
    [PLAN_INCLUSION_TYPE.event_associations]: {
      ...defaultFieldData,
    },
  }[type];

  return list.map((data) => ({
    type: PLAN_INCLUSION_TYPE_DATA[type],
    get status() {
      const { status, reason } = data?.pivot || {};
      return {
        reason,
        ...PLAN_INCLUSION_STATUS_DATA[status || PLAN_INCLUSION_STATUS.request],
      };
    },
    name: data[dataField.name],
    id: data[dataField.id],
    data,
  }));
};
export default class EventAnnouncement extends BaseModel {
  #user;

  constructor(eventAnnouncement, url) {
    super(eventAnnouncement, url);

    this.id = eventAnnouncement.id;
    this.name = eventAnnouncement.name;
    this.description = eventAnnouncement.description; // string | null
    this.start_at = localeFormatDefault(eventAnnouncement.start_at);
    this.end_at = localeFormatDefault(eventAnnouncement.end_at);

    this.owner_id = eventAnnouncement.owner_id;

    // From expand
    this.owner = eventAnnouncement?.owner || null;
    this.event = eventAnnouncement?.event ? new Event(eventAnnouncement.event) : null;
    // Plan inclusion (requests)
    this[PLAN_INCLUSION_TYPE.organizers] = eventAnnouncement?.[PLAN_INCLUSION_TYPE.organizers] || [];
    this[PLAN_INCLUSION_TYPE.municipalities] = eventAnnouncement?.[PLAN_INCLUSION_TYPE.municipalities] || [];
    this[PLAN_INCLUSION_TYPE.regions] = eventAnnouncement?.[PLAN_INCLUSION_TYPE.regions] || [];
    this[PLAN_INCLUSION_TYPE.event_associations] = eventAnnouncement?.[PLAN_INCLUSION_TYPE.event_associations] || [];

    this.#user = new User();
  }

  get isOwner() {
    return this.#user?.isAuthenticated && this.owner_id === this.#user?.data?.id;
  }

  get ownerRole() {
    const [ownerRole] = this.owner?.roles || [];
    return ownerRole || ROLES_DATA[ROLES.organization];
  }

  get executionTime() {
    const { start_at, end_at } = this;
    return getAnnounDate(start_at, end_at);
  }

  /** Трансформируем все заявки
   * @return Array<Object>
   */
  get mappedInclusionsRequests() {
    return Object.values(PLAN_INCLUSION_TYPE).map((type) => requestsDataMap(this[type] || [], type)).flat();
  }

  /** Все заявки в статусе "на рассмотрении"
   * @return Array<Object>
   */
  get consideredInclusionsRequests() {
    return this.mappedInclusionsRequests.filter(({ status: { id } }) => id === PLAN_INCLUSION_STATUS.request);
  }

  /**  Фильтруем заявки, чтобы:
   * 1. не было НАШЕЙ заявки к НАМ ЖЕ (они на беке автоматически создаются, всегда сразу активны)
   * 2. не было заявки к НАМ, если я ещё уже принял
   * @return Array<Object>
   */
  get othersInclusionsRequests() {
    const { mappedInclusionsRequests } = this;
    const { data } = this.#user || {};
    return mappedInclusionsRequests.filter((item) => item.id !== data[PLAN_INCLUSION_TYPE_DATA[item.type.id].userField]?.id);
  }

  get othersActiveInclusionsRequests() {
    return this.othersInclusionsRequests.filter(({ status }) => status.id === PLAN_INCLUSION_STATUS.accepted);
  }

  attachEvent(payload) {
    const args = [this.id];
    return rServices.eventAnnouncements.attachEvent({ args, data: payload });
  }

  detachEvent(payload) {
    const args = [this.id];
    return rServices.eventAnnouncements.detachEvent({ args, data: payload });
  }

  request(payload) {
    const args = [this.id];
    return rServices.eventAnnouncements.request({ args, data: payload });
  }

  accept(payload) {
    const args = [this.id];
    return rServices.eventAnnouncements.accept({ args, data: payload });
  }

  reject(payload) {
    const args = [this.id];
    return rServices.eventAnnouncements.reject({ args, data: payload });
  }

  detach(payload) {
    const args = [this.id];
    return rServices.eventAnnouncements.detach({ args, data: payload });
  }
}
